import { render, staticRenderFns } from "./StagingAuthorFormCard.vue?vue&type=template&id=40f5187e"
import script from "./StagingAuthorFormCard.vue?vue&type=script&lang=ts"
export * from "./StagingAuthorFormCard.vue?vue&type=script&lang=ts"
import style0 from "./StagingAuthorFormCard.vue?vue&type=style&index=0&id=40f5187e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports